export function validateUserPassword(password: string) {
  let errors: string[] = [];
  if (password.length < 8) errors.push("Password must have at least 8 characters");
  if (!password.match(/\d/)) errors.push("Password must have numbers");
  if (!password.match(/(?=.*[a-z])/)) errors.push("Password must have lowercase letters");
  if (!password.match(/(?=.*[A-Z])/)) errors.push("Password must have uppercase letters");

  return errors;
}

export function swapArrayItems(arr: any[], sourceIndex: number, destinationIndex: number) {
  if (destinationIndex >= arr.length) {
    let k = destinationIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(destinationIndex, 0, arr.splice(sourceIndex, 1)[0]);
  return arr; // for testing
}
